// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2xA8a","requiredAsterisk":"Info_requiredAsterisk__30RQK"};